import Vue from 'vue'
import App from './App.vue'

import vuetify from './plugins/vuetify';
import router from './router'
import store from './store'
import Axios from 'axios';
import redditApi from "@/services/redditApi";
import VueGtag from "vue-gtag";
import VueFileAgent from 'vue-file-agent';


Vue.config.productionTip = false
Vue.prototype.$http = Axios;
Vue.prototype.$redditApi = redditApi;
const token = localStorage.getItem('token')
if (token) {
  Vue.prototype.$redditApi.defaults.headers.common['Authorization'] = `Bearer ${token}`
}
Vue.use(VueGtag, {
  config: { id: "UA-73611216-2" }
}, router);
Vue.use(VueFileAgent);
new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
